export const GETURL = 'https://back.talkofthetown.com.br'
export const POSTURL = 'https://back.talkofthetown.com.br'
export const LOADER = require('../images/loading.svg')
